
export default class ProjectTeamMember {
  id?: number;
  fullName: string;
  jobTitle: string;
  description: string;
  profilePicture?: {
    url: string,
    encoded?: string,
    ext?: string,
    name?: string,
  };
  linkedinProfile?: string;

  constructor(entity: ProjectTeamMember) {
    this.id = entity.id;
    this.fullName = entity.fullName;
    this.jobTitle = entity.jobTitle;
    this.description = entity.description;
    this.profilePicture = entity.profilePicture;
    this.linkedinProfile = entity.linkedinProfile;
  }
}



// WEBPACK FOOTER //
// ./src/value-objects/ProjectTeamMembers.tsx